import { z } from 'zod';
export const createInvitationSchema = z.object({
    email: z.string().email(),
    role: z.enum(['CLIENT', 'VENDOR']),
    eventId: z.string().uuid(),
});
export const acceptInvitationSchema = z.object({
    name: z.string().min(1).optional(),
});
//# sourceMappingURL=invitation.js.map